import {
  Component,
  forwardRef,
  OnChanges,
  OnInit,
  Renderer2,
} from "@angular/core";
import { Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import { VendorService } from "../../../../core/services/vendor.service";
import { SharedService } from "../../../../core/services/shared.service";
import { GetAllVendorsDto } from "../../../../core/models/vendor/vendorListing/getAllVendors";
import { RatingModule } from "primeng/rating";
import { CommonModule } from "@angular/common";
import {
  TableFilterEvent,
  TableModule,
  TableLazyLoadEvent,
} from "primeng/table";
import { VendorSummaryComponent } from "../vendor-summary/vendor-summary.component";
import { ClientsListingService } from "../../../../core/services/clients-listing.service";
import { VendorFeedbackRatingComponent } from "../vendor-feedback-rating/vendor-feedback-rating.component";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { FormsModule } from "@angular/forms";
import { CardModule } from "primeng/card";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { DrawerModule } from "primeng/drawer";
import { ToggleButtonModule } from "primeng/togglebutton";
import { ButtonModule } from "primeng/button";
import { PopoverModule } from "primeng/popover";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { FilterMetadata } from "primeng/api";
import { GenericRequestDto } from "../../../../core/models/common/genericRequestDto";
import { debounceTime, distinctUntilChanged, Subject } from "rxjs";
import { GenericFilterRequestDto } from "../../../../core/models/common/genericFilterRequestDto";
import { GenericSortRequestDto } from "../../../../core/models/common/genericSortRequestDto";

@UntilDestroy()
@Component({
  selector: "jni-vendorlisting",
  templateUrl: "./vendor-listing.component.html",
  styleUrls: ["./vendor-listing.component.scss"],
  imports: [
    RatingModule,
    CommonModule,
    TableModule,
    forwardRef(() => VendorSummaryComponent),
    VendorFeedbackRatingComponent,
    ModalStackerComponent,
    FormsModule,
    CardModule,
    ToggleSwitchModule,
    DrawerModule,
    ToggleButtonModule,
    ButtonModule,
    PopoverModule,
    SpinnerComponent,
  ],
})
export class VendorlistingComponent implements OnInit, OnChanges {
  constructor(
    private _router: Router,
    private _vendorService: VendorService,
    public _clientsListingService: ClientsListingService,
    private renderer: Renderer2,
    private _sharedService: SharedService
  ) {
    this.closeModalOnVendor();
  }

  vendorListings: GetAllVendorsDto[] = [];
  filteredDataVendorLists: GetAllVendorsDto[] = [];
  selectedVendors: GetAllVendorsDto[] = [];
  showLoader = false;
  vendorDisplayModal = false;
  vendorAccountNumber = "";
  vendorListingModalStatus = false;
  totalRecords = 0;
  defaultTake = 50;
  lazyLoadEvent!: TableLazyLoadEvent;
  filterTextChanged: Subject<Event | string | null> = new Subject<
    Event | string | null
  >();
  filterDebounceTime = 1000;

  ngOnInit(): void {
    //this.getAllVendorsListingData();
    this.closeModalOnVendor();
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  closeModalOnVendor() {
    this.vendorDisplayModal = false;
  }

  ngOnChanges() {
    if (this.vendorAccountNumber) {
      this.vendorListingModalStatus = true;
    }
  }

  getCurrentVendor(accountnumber: string) {
    if (accountnumber) {
      this.vendorAccountNumber = accountnumber;
      this.vendorDisplayModal = true;
    }
  }

  closeModal() {
    this.vendorDisplayModal = false;
  }

  onVendorRedirection() {
    this._router.navigate(["/vendors/add-vendor"]);
  }

  getAllVendorsListingData(event: TableLazyLoadEvent) {
    this.showLoader = true;
    this.lazyLoadEvent = event;
    const eventFilterArray = Object.keys(event.filters ?? {});

    const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      const tableFilter = event?.filters?.[x] as FilterMetadata;
      const data = {
        columnName: x ?? "",
        matchMode: tableFilter.matchMode ?? "",
        tableName: "",
        value: tableFilter.value ?? "",
      } as GenericFilterRequestDto;

      return data;
    });

    const sortArray: GenericSortRequestDto[] =
      event.multiSortMeta?.map(x => {
        return {
          ...x,
        } as GenericSortRequestDto;
      }) ?? [];

    filter.forEach(x => {
      if (x.columnName == "vendorAccountNumber") {
        x.columnName = "vendorAccountNumber";
        x.tableName = "Vendors";
      }

      if (x.columnName == "vendorGroup") {
        x.columnName = "vendorGroup";
        x.tableName = "VendorGroups";
      }

      if (x.columnName == "vendorName") {
        x.columnName = "vendorName";
        x.tableName = "Vendors";
      }
    });

    // this._loaderService.setLoaderState(true);
    const request: GenericRequestDto = {
      skip: event.first ?? 0,
      take: event.rows ?? this.defaultTake,
      filters: filter,
      sort: sortArray,
    };
    this._vendorService
      .getAllVendor(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<GetAllVendorsDto[]>) => {
          this.vendorListings = res.data;
          this.filteredDataVendorLists = this.vendorListings;
          this.showLoader = false;
          this.totalRecords = res.totalRecords ?? 0;
        },
      });
  }

  exportExcel() {
    this.showLoader = true;
    this.exportExcelForFilterData(this.filteredDataVendorLists);
    this.showLoader = false;
  }

  exportExcelForFilterData(filterclientlist: GetAllVendorsDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Account Number"]: datum.vendorAccountNumber,
        ["Group"]: datum.vendorGroup,
        ["Vendor Name"]: datum.vendorName,
        ["Known AS"]: datum.vendorKnownAs,
        ["Phone Number"]: datum.phoneNumber,
        ["City"]: datum.city,
        ["State"]: datum.state,
        ["Country"]: datum.country,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "VendorList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  checkboxSelection() {
    if (this.selectedVendors.length > 1 || this.selectedVendors.length == 0) {
      this._clientsListingService.setAttachmentState(true);
    } else {
      this._clientsListingService.setAttachmentState(false);
    }
  }

  getRating(score: string | null) {
    return parseInt(score ?? "0");
  }

  addScollHiddenClass() {
    if (this.vendorListingModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    } else {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }
  }

  onFilter(event: TableFilterEvent) {
    if (event?.filters && event?.filteredValue?.length !== 0) {
      this.filteredDataVendorLists = event.filteredValue;
    } else {
      this.filteredDataVendorLists = this.vendorListings;
    }
  }

  onFilterInput($event: Event | string | null) {
    this.filterTextChanged
      .pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged())
      .subscribe(() => {
        this.getAllVendorsListingData(this.lazyLoadEvent);
      });
    this.filterTextChanged.next($event);
  }
}
